<template>
  <div>

    <div v-if="showAddButton" class="product-stage-action-buttons">
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
          @click="openAddProductModal()"
      >
        <i class="fas fa-plus-circle"/>
        Utwórz nowy towar
      </div>
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm ms-2"
          @click="openImportAssistant()"
      >
        <i class="fas fa-file-upload"/>
        Importuj produkty
      </div>

    </div>


    <div class="product-data-stage">

      <div class="product-data-table-container">
        <div>
          <SearchBar2
              :searchOptions="fieldsAvailableForSearch"
              @searchRequest="searchOnList($event)"
              :defaultSearchField="'name'"
          />
        </div>

        <div>
          <CommonTable2
              ref="productsCommonTable"
              :table="tableData"
              rowIdentifier="guid"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              @onSelectRow="selectRow($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getProductsDataTotal"
              :totalPages="commonModule.getProductsDataPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              :multiselect="multiselect"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="showMassActions"
              :showRowActions="showRowActions"
              :initiallyCheckedItemsData="selectedProductsData"
              :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
              :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
              :initiallyVisibleColumns="visibleColumnsFilterLocal"
              :enableRowSelection="enableRowSelection"
              :showCheckboxColumn="showCheckboxColumn"
              :stickyScrollbarBottom="0"
              :exportEnabled="true"
              @onExportTableData="exportProducts"
              @onVisibleColumnsChange="saveVisibleColumns"
          />
        </div>
        <slot name="bottom"></slot>
      </div>
    </div>

    <b-modal
        v-model="showProductDataModal"
        id="product-data-form-modal"
        scrollable
        :title="productDataModalTitle"
        title-class="font-18"
        hide-footer
        size="lg"
        style="z-index:100020!important;"
        @hide="closeProductDataModal()"
    >
      <div v-if="showProductDataModal" style="margin-top: 20px!important;">
        <CommonForm
            id="product-data-form"
            :structure="productDataFormStructure"
            :data="currentProductDataFormData"
            :key="currentProductDataFormData"
            @onSubmit="saveProductData($event)"
            @onCancel="cancelProductDataEdit"
            submitButtonText="Zapisz"
            :submitButtonEnabled="true"
            cancelButtonText="Anuluj"
            :cancelButtonEnabled="true"
        >
          <template v-if="currentProductDataFormData.guid != null" v-slot:bindLocalProductsActions>
            <div class="row">
              <div class="col-6" style="text-align: center;">
                <div class="btn btn-info" @click="showBoundLocalProductsModal = true"><i class="fa fa-search-minus"/>Pokaż
                  powiązane lokalne towary
                </div>
              </div>
              <div class="col-6" style="text-align: center;">
                <div class="btn btn-success" @click="showBindingModeLocalProductsModal = true"><i class="fa fa-link"/>Powiąż
                  lokalne towary
                </div>
              </div>


            </div>
          </template>


        </CommonForm>
      </div>


    </b-modal>
    <b-modal
        v-model="showProductImportAssistant"
        title="Import towarów"
        scrollable
        hide-footer
        style="z-index:100011!important;"
        size="xl"
    >
      <ProductsImportAssistant
          v-if="showProductImportAssistant"
          title="Asystent importu towarów"
          @onImportSuccess="onImportSuccess"
      />
    </b-modal>

    <b-modal
        v-model="showBoundLocalProductsModal"
        id="central-product-binding-form-modal"
        scrollable
        title="Lista lokalnych towarów powiązanych z towarem centralnym"
        title-class="font-18"
        size="xl"
        style="z-index:100030!important;"
        :okDisabled="true"
        :cancelDisabled="true"
        :hideFooter="true"

    >
      <div class="form-group">
        <label>Towar centralny:
          {{ currentProductDataFormData.name }}</label>
        <div v-if="showBoundLocalProductsModal">


          <BoundLocalProductsList
              :boundWithCentralGuid="currentProductDataFormData.guid"
              @onSelect="selectLocalProduct"
              @onUnbind="refreshBoundProductsList"
              @onBind="refreshBoundProductsList"
              :bindModeOn="false"

          />
        </div>
      </div>


    </b-modal>

    <b-modal
        v-model="showBindingModeLocalProductsModal"
        id="central-product-binding-form-modal"
        scrollable
        title="Powiąż wybrane towary lokalne z towarem centralnym"
        title-class="font-18"
        size="xl"
        style="z-index:100030!important;"
        :okDisabled="true"
        :cancelDisabled="true"
        :hideFooter="true"

    >
      <div class="form-group">
        <label>Wybrany towar centralny:
          {{ currentProductDataFormData.name }}</label>
        <div v-if="showBindingModeLocalProductsModal">


          <BoundLocalProductsList
              :boundWithCentralGuid="currentProductDataFormData.guid"
              @onSelect="selectLocalProduct"
              @onUnbind="refreshBoundProductsList"
              @onBind="refreshBoundProductsList"
              :bindModeOn="true"

          />
        </div>
      </div>


    </b-modal>


  </div>
</template>

<script>

import {BModal} from "bootstrap-vue-next";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import CommonForm from "@/components/widgets/CommonForm.vue";
import {productFormFields} from "./data/productFormFields";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {commonAppHelperMethods} from "./helper/commonAppHelperMethods";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import Swal from "sweetalert2";
import BoundLocalProductsList from "./BoundLocalProductsList.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import ProductsImportAssistant from "@/views/DrugstoreCommonManager/ProductsImportAssistant.vue";
import {useCommonExportModule, useUserProfileModule} from "@/state/pinia";
import {USER_PROFILE_CONFIG_VIEW_KEYS} from "@/helpers/userProfileConfigViewKeys";
import {
  applyTableUserProfileSettings,
  buildSortingSetting, buildVisibleColumnsSetting,
  findSettingByKey, loadUserProfileViewConfigRuntime,
  mergeSettingIntoArray,
  parseJsonSettingValue, saveSortingSettingRuntime, saveUserProfileSettingsRuntime, saveVisibleColumnsRuntime
} from "@/helpers/userProfileConfigHelper";


export default {
  name: "ProductDataList",
  props: {
    multiselect: {
      type: Boolean,
      default: true,
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
    showRowActions: {
      type: Boolean,
      default: () => true
    },
    showAddButton: {
      type: Boolean,
      default: () => true
    },
    selectedProductsData: {
      type: Array,
      default: () => []
    },
    disableInitiallyCheckedItems: {type: Boolean, default: () => false},
    ignoreInitiallyCheckedItems: {type: Boolean, default: () => false},
    visibleColumnsFilter: { // declare only columns keys You want to see
      type: Array,
      default: () => []
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },


  },
  emits: ["onSelect", "applyItemsInSelectMode", "onSelectRow"],
  components: {
    ProductsImportAssistant,
    BoundLocalProductsList,
    BModal,
    CommonForm,
    SearchBar2,
    CommonTable2,
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "name",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      productDataRows: [],
      productDataModalTitle: "",
      showBoundLocalProductsModal: false,
      showBindingModeLocalProductsModal: false,
      tableMassActions: [
        {
          text: "Usuń",
          icon: "fas fa-trash",
          action: "delete-product-data",
          class: "btn btn-danger table-actions-button edit-button",
          enabled: true,
          tooltip: "Usuń zaznaczone towary",
        },
        {
          text: "Scal towary",
          icon: "fas fa-link",
          action: "merge-products",
          class: "btn btn-success table-actions-button edit-button",
          enabled: true,
          tooltip: "Scal towary centralne w jedną kartotekę",
        }
      ],
      fieldsAvailableForSearch: [
        {
          name: "Bloz",
          key: "bloz",
        },
        {
          name: "EAN",
          key: "ean",
        },
        {
          name: "Nazwa towaru",
          key: "name",
        },
        {
          name: "Producent",
          key: "manufacturer",
        },
      ],
      availableHeaders: [
        {
          text: "ID",
          key: "id",
          type: "number",
          sortable: true,
        },
        {
          text: "CKT",
          key: "centralCartReference",
          type: "number",
          sortable: true,
        },

        {
          text: "Bloz",
          key: "bloz",
          type: "number",
          sortable: true,
        },
        {
          text: "EAN",
          key: "ean",
          type: "text",
          sortable: true,
        },
        {
          text: "Nazwa towaru",
          key: "name",
          type: "text",
          sortable: true,
        },
        {
          text: "Producent",
          key: "manufacturer",
          type: "text",
          sortable: true
        },
        {
          text: "Utworzono",
          key: "createdAt",
          type: "text",
          sortable: true
        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions: [
            {
              text: "",
              icon: "fas fa-edit",
              action: "edit-product-data",
              enabled: true,
              tooltip: "Edytuj towar",
              class: "btn btn-info btn-sm table-actions-button edit-button",
            },
            {
              text: "",
              icon: "fas fa-trash",
              action: "delete-product-data",
              enabled: true,
              tooltip: "Usuń towar",
              class: "btn btn-danger btn-sm table-actions-button edit-button",
            }


          ],
        },
      ],
      refreshTable: true,
      showProductDataModal: false,
      productDataFormStructure: productFormFields.productDataForm,
      currentProductDataFormData: {},
      emptyProductDataFormData: {
        guid: null,
        name: null,
        address: null,
        city: null,
        zipcode: null,
        bankAccount: null,
        bankName: null,
        nip: null,
        regon: null,
        phone: null,
        email: null,
        concession: null,
        centralId: null,
        isOwnProduct: false,
        createdAt: null,
      },
      showProductImportAssistant: false,
      userProfileSettings: [],
      // user profile settings
      currentViewKey: USER_PROFILE_CONFIG_VIEW_KEYS.PRODUCTS_TABLE,
      currentViewContext: null,
      isApplyingUserProfileConfig: false,
      visibleColumnsFilterLocal: [],
    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    commonExportModule() {
      return useCommonExportModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    userProfileModule() {
      return useUserProfileModule();
    },
  },
  methods: {
    exportProducts(event) {
      const payload = {
        exportType: "products",
        outputFileFormat: "XLSX",
        defaultFileNamePrefix: "towary_",
        columns: event.visibleHeaders,
        params: {
          selectedItems: event.selectedItems
        }
      }
      this.commonExportModule.httpExportGenericTable(payload);

    },

    openImportAssistant() {
      this.showProductImportAssistant = true;
    },
    onImportSuccess(successStr) {
      // close modal and refresh on success
      if (successStr === 'true') {
        this.showProductImportAssistant = false;
        this.refreshProductData();
      }
    },
    resetSelectedProducts() {
      this.$refs.productsCommonTable.resetCheckedItems();
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshProductData();
    },
    runAction(event) {
      if (event.action.action === "edit-product-data") {
        log.log(event);
        var payload = {
          guid: event.itemData.guid,
        };

        this.commonModule.httpGetProductByGuid(payload).then((response) => {
          log.log(response);
          if (response.status === 200) {
            this.currentProductDataFormData = JSON.parse(JSON.stringify(response.data.payload));
            this.productDataModalTitle = "Edytuj towar centralny";
            this.showProductDataModal = true;
          } else if (response.status === 203) {
            this.showProductDataModal = false;
            apiRequestsHelper.handleResponseWithDialogs(response, false);
          }
        }).catch((error) => {
          return apiRequestsHelper.catchResponseError(error, "httpGetProductByGuid");
        });
      } else if (event.action.action === "delete-product-data") {
        this.deleteProductsByGuids([event.itemData.guid]);
      } else if (event.action.action === "row-apply-in-select-mode") {
        log.log("Running apply event")
        this.$emit("applyItemsInSelectMode", [event.itemData.guid])
      }
    },

    openAddProductModal() {
      this.currentProductDataFormData = JSON.parse(JSON.stringify(this.emptyProductDataFormData));
      this.productDataModalTitle = "Dodaj towar centralny";
      this.showProductDataModal = true;


    },

    runMassAction(event) {
      log.log(event);
      if (event.action.action === "delete-product-data") {
        this.deleteProductsByGuids(event.items)
      } else if (event.action.action === "merge-products") {
        this.mergeProductsAndRemove(event.items).then(() => {
          this.refreshProductData();
        });
      } else if (event.action.action === "mass-apply-in-select-mode") {
        this.$emit("applyItemsInSelectMode", event.items)
      }
    },
    deleteProductsByGuids(guids, isMerge = false) {
      var dialogTitle = "Usunąć towary?";
      var dialogText = "Czy na pewno usunąć wybrane towary z bazy centralnych towarów?. Operacja jest nieodwracalna!";
      var dialogIcon = "warning";
      if (isMerge) {
        dialogTitle = "Czy usunać źródłowe towary?";
        dialogText = "Czy usunać źródłowe towary i pozostawić tylko towar docelowy?. Towary źródłowe nie mają już dowiązanych żadnych lokalnych towarów.";
        dialogIcon = "success";
      }

      // ask user if is sure to do that:
      Swal.fire({
        title: dialogTitle,
        text: dialogText,
        icon: dialogIcon,
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        customClass: {
          container: "swal-highest"
        },
        dangerMode: true,
      }).then((result) => {
        if (result.value) {
          var payload = {
            guids: guids,
          };

          this.commonModule.httpDeleteProductsByGuids(payload).then(() => {
            this.refreshProductData();
          });
        } else {
          // Do nothing...
        }
      });


    },

    mergeProductsAndRemove(guidsSelected) {
      return this.mergeProducts(guidsSelected).then((response) => {
        if (response.isConfirmed === true) {
          const targetProductGuid = response.targetProductGuid;
          // remove target product guids from selected guids that are about to be deleted:
          const guidsSelectedWithoutTarget = guidsSelected.filter(item => item !== targetProductGuid);

          return this.deleteProductsByGuids(guidsSelectedWithoutTarget, true);
        }
      });
    },

    mergeProducts(guidsSelected) {
      var selectedProducts = [];

      for (var i = 0; i < guidsSelected.length; i++) {
        this.productDataRows.find((item) => {
          if (item.guid === guidsSelected[i]) {
            var productToSelect = "[ID: " + item.id + "] " + item.name;
            selectedProducts.push(productToSelect);
          }
        });
      }

      // open Swal dialog with selectbox containing selected products:
      var targetCentralProduct = null;
      return Swal.fire({
        title: "Wybierz towar docelowy, a nastepnie kliknij 'Scal' aby połączyć towary",
        html: '<select id="swal-select" class="swal2-select" style=" margin-left: unset!important;margin-right: unset!important;">' +
            '<option value="">Wybierz towar docelowy</option>' +
            selectedProducts.map((item) => {
              return '<option value="' + item + '">' + item + '</option>';
            }).join('') +
            '</select>',
        showCancelButton: true,
        confirmButtonText: "Scal",
        cancelButtonText: "Anuluj",
        customClass: {
          container: "swal-highest"
        },
        preConfirm: () => {
          var selectedCentralProductToBind = document.getElementById("swal-select").value;
          // parse selectedCentralProductToBind to ID:
          const id = this.extractID(selectedCentralProductToBind.toString());
          this.productDataRows.find((item) => {
            if (item.id === parseInt(id)) {
              targetCentralProduct = item;
            }
          });

        }
      }).then((result) => {
        if (result.isConfirmed) {

          if (targetCentralProduct == null) {
            Swal.fire({
              title: "Brak docelowego centralnego towaru",
              text: "Nie wybrano centralnego towaru do powiązania.",
              icon: "info",
              confirmButtonText: "OK",
              customClass: {
                container: "swal-highest"
              },
            });
            return new Promise((resolve) => {
              resolve({isConfirmed: false});
            });
          } else {
            this.lazyloaderModule.setDisplayLazyLoader(true);
            this.lazyloaderModule.setProgressBarMessage("Scalanie centralnych kartotek...");
            var payload = {
              targetCentralProductGuid: targetCentralProduct.guid,
              sourceCentralProductsGuids: guidsSelected
            }

            return this.commonModule.httpMergeCentralProducts(payload)
                .then((response) => {
                  if (response.status === 200) {
                    return new Promise((resolve) => {
                      resolve({
                        isConfirmed: true,
                        targetProductGuid: targetCentralProduct.guid

                      });
                    });
                  }
                  return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                  return apiRequestsHelper.catchResponseError(error, "httpMergeCentralProducts");
                });


          }
        } else {
          return new Promise((resolve) => {
            resolve({isConfirmed: false});
          });
        }

      });
    },

    extractID(str) {
      const match = str.match(/\[ID: (\d+)\]/);
      return match ? match[1] : null;
    },


    async sort(sortKey) {
      log.log(sortKey);

      let nextDirection = "ASC";

      if (this.sortingKey === sortKey) {
        nextDirection = this.sortingDirection === "ASC" ? "DESC" : "ASC";
      } else {
        nextDirection = "ASC";
      }

      this.sortingKey = sortKey;
      this.sortingDirection = nextDirection;

      await this.saveSortingSetting(this.sortingKey, this.sortingDirection);
      this.refreshProductData();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      this.$emit("onSelect", event.itemsData);

    },
    selectRow(event) {
      log.log(event);
      this.$emit("onSelectRow", event);
    },
    refreshProductData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o towarch.");
      this.refreshProductDataList();
    },
    refreshProductDataList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy towarów.");
      this.commonModule.setProductsData([]);

      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: null,
      };

      var payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
      };
      this.refreshTable = false;
      this.commonModule.httpGetProductsPaging(payload).then(() => {
        this.productDataRows = [];
        var productData = JSON.parse(JSON.stringify(this.commonModule.getProductsData));
        for (var i = 0; i < productData.length; i++) {
          productData[i]["createdAt"] = commonAppHelperMethods.formatDatetimeToLocaleFormat(productData[i]["createdAt"]);
          this.productDataRows.push(productData[i]);
        }

        var productsHeaders = []
        for (var j = 0; j < this.availableHeaders.length; j++) {
          if (this.availableHeaders[j].key === "nip") {

            this.availableHeaders[j].class = "sticky-header col-mid-text";
            productsHeaders.push(this.availableHeaders[j]);
          } else if (this.availableHeaders[j].key === "nazwa_kartoteki_centralnej_towaru") {
            this.availableHeaders[j].sortable = false;
            productsHeaders.push(this.availableHeaders[j]);
          } else {
            productsHeaders.push(this.availableHeaders[j]);
          }
        }


        this.tableData["headers"] = productsHeaders;
        if (this.disableInitiallyCheckedItems) {
          var actionsHeaderIndex = this.tableData["headers"].findIndex(header => header.key === "actions");
          if (actionsHeaderIndex !== -1) {
            // If found, add apply action

            const applyInSelectModeActionIndex = this.tableData["headers"][actionsHeaderIndex].actions.findIndex(action => action.action === "row-apply-in-select-mode");
            if (applyInSelectModeActionIndex === -1) { // add row-apply-in-select-mode action only if not already added
              this.tableData["headers"][actionsHeaderIndex].actions.push(
                  {
                    text: "Wybierz towar",
                    icon: "",
                    action: "row-apply-in-select-mode",
                    enabled: true,
                    tooltip: "Wybierz towar",
                    class: "btn btn-info btn-sm table-actions-button edit-button",
                  }
              )
            }


          }

        }


        this.tableData["massActions"] = this.tableMassActions;
        if (this.disableInitiallyCheckedItems) {
          this.tableData["massActions"].push({
            text: "Wybierz zaznaczone",
            icon: "",
            action: "mass-apply-in-select-mode",
            class: "btn btn-info table-actions-button edit-button",
            enabled: true,
            tooltip: "Wybierz zaznaczone towary",
          })
        }
        this.tableData["data"] = this.productDataRows;
        this.refreshTable = true;
      });
    },
    saveProductData(event) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapisywanie zmian w towarze");

      var currentSelectedProductGuid = this.currentProductDataFormData.guid;
      if (currentSelectedProductGuid == null) {
        var createPayload = {
          productData: event
        }
        this.commonModule.httpAddProduct(createPayload).then(() => {
          this.currentProductDataFormData = JSON.parse(JSON.stringify(this.emptyProductDataFormData));
          this.showProductDataModal = false;
          this.refreshProductData();
        });

      } else {
        var updatePayload = {
          productData: event,
          guid: this.currentProductDataFormData.guid,
        };
        this.commonModule.httpUpdateProductData(updatePayload).then(() => {
          this.currentProductDataFormData = JSON.parse(JSON.stringify(this.emptyProductDataFormData));
          this.showProductDataModal = false;
          this.refreshProductData();
        });
      }


    },
    closeProductDataModal() {
      log.log("closing product data modal");
      this.showProductDataModal = false;
    },
    cancelProductDataEdit() {
      this.showProductDataModal = false;
    },
    selectLocalProduct(selectedProduct) {
      // no need to do anything here
      log.log(selectedProduct);
    },
    refreshBoundProductsList() {
      log.log("refreshing bound products list");

    },
    async loadUserProfileViewConfig() {
      try {
        await loadUserProfileViewConfigRuntime({
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
          onLoadingChange: (value) => {
            this.isApplyingUserProfileConfig = value;
          },
          onSettingsLoaded: (settings) => {
            this.userProfileSettings = [...settings];
            this.applyUserProfileSettingsToComponent(settings);
          },
        });
      } catch (e) {
        console.error("Błąd podczas ładowania konfiguracji widoku użytkownika:", e);
      }
    },
    applyUserProfileSettingsToComponent(settings) {
        console.log("applying user profile settings to component",this.visibleColumnsFilter);
      const applied = applyTableUserProfileSettings({
        settings,
        fallbackVisibleColumns: this.availableHeaders.filter(item => this.visibleColumnsFilter.includes(item.key)),
        fallbackSortingKey: this.sortingKey,
        fallbackSortingDirection: this.sortingDirection,
      });
      this.visibleColumnsFilterLocal = [...applied.visibleColumns.map(item => item.key)];
      this.sortingKey = applied.sortingKey;
      this.sortingDirection = applied.sortingDirection;
    },

    async saveVisibleColumns(columnKeys) {
      try {
        const result = await saveVisibleColumnsRuntime({
          currentSettings: this.userProfileSettings,
          columnKeys,
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
        });

        this.userProfileSettings = [...result.savedSettings];
        this.visibleColumnsFilterLocal = [...result.savedVisibleColumns];
      } catch (e) {
        console.error("Błąd podczas zapisu ustawienia visible columns:", e);
      }
    },
    async saveSortingSetting(sortColumn, sortDirection) {
      try {
        const result = await saveSortingSettingRuntime({
          currentSettings: this.userProfileSettings,
          sortColumn,
          sortDirection,
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
        });

        this.userProfileSettings = [...result.savedSettings];
      } catch (e) {
        console.error("Błąd podczas zapisu ustawienia sortowania:", e);
      }
    },

  },
  watch: {
    currentPage: {
      handler() {
        this.loadUserProfileViewConfig().then(() => {
          this.refreshProductData();
        })
      },
      deep: true,
    },
  },
  created() {
    this.visibleColumnsFilterLocal = [...this.visibleColumnsFilter];
    this.loadUserProfileViewConfig().then(() => {
      this.refreshProductData();
    })
  },
};
</script>

<style scoped>
.product-data-stage {
  margin-left: 2px;
  margin-right: 2px;
}

.product-data-table-container {
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}

.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.product-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.swal2-select {
  width: 100%;
  margin-left: unset !important;
  margin-right: unset !important;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
